export const PERSPECTIVE_KEY_DISCOVER = 'discover';
export const PERSPECTIVE_KEY_SEARCH = 'search';